










































































































































import {
  ref,
  defineComponent,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import { useInputRules } from "@/ts/functions/composition/inputRules";
import { capitalize } from "@/ts/functions/vueFilters";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";
import LoadingBar from "@c/atoms/app/LoadingBar.vue";
import PageTitle from "@c/atoms/app/PageTitle.vue";
import ConfirmDialog from "@c/molecules/app/ConfirmDialog.vue";
import ImageInput from "@c/molecules/media/ImageInput.vue";
import UserModel from "@/ts/models/userClass";
import ImageModel from "@/ts/models/imageClass";
import TagsInput from "@c/molecules/tag/TagsInput.vue";

export default defineComponent({
  name: "Settings",

  components: {
    PrimaryContentBody,
    PageTitle,
    ConfirmDialog,
    ImageInput,
    LoadingBar,
    TagsInput
  },

  setup(props, { root }) {
    const rules = useInputRules();

    var modified = ref(false);
    var form = ref(false);
    var show_password = ref(false);
    var dialog = ref(false);
    var loading = ref(false);
    var loading_deletion = ref(false);

    const { SEND_USER_EDITION } = useActions({
      SEND_USER_EDITION: "auth/SEND_USER_EDITION"
    } as any);
    const { SEND_DELETE_USER } = useActions({
      SEND_DELETE_USER: "auth/SEND_DELETE_USER"
    } as any);
    const { SEND_LOGOUT_REQUEST } = useActions({
      SEND_LOGOUT_REQUEST: "auth/SEND_LOGOUT_REQUEST"
    } as any);
    const { user } = useGetters({ user: "auth/user" } as any);
    var { errors } = useGetters({ errors: "app/errors" } as any);

    var editedUser = ref<UserModel>(JSON.parse(JSON.stringify(user.value)));

    watch(
      () => editedUser.value,
      (newValue: any) => {
        modified.value = true;
      },
      { deep: true }
    );

    const deleteUser = () => {
      loading_deletion.value = true;
      SEND_DELETE_USER(user.value)
        .then(() => {
          loading_deletion.value = false;
          root.$router.push("/").catch(() => {});
        })
        .catch(() => {
          loading_deletion.value = false;
          dialog.value = false;
        });
    };

    const editUser = () => {
      loading.value = true;
      SEND_USER_EDITION(editedUser.value)
        .then(() => {
          loading.value = false;
          modified.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const logout = () => {
      SEND_LOGOUT_REQUEST();
    };

    return {
      dialog,
      loading,
      loading_deletion,
      editedUser,
      SEND_USER_EDITION,
      SEND_DELETE_USER,
      SEND_LOGOUT_REQUEST,
      logout,
      editUser,
      deleteUser,
      show_password,
      rules,
      errors,
      form,
      modified
    };
  }
});
